export default from './App'



// WEBPACK FOOTER //
// ./src/app/templates/App/index.js